import { render, staticRenderFns } from "./ModalComment.vue?vue&type=template&id=4cecca8d&scoped=true"
import script from "./ModalComment.vue?vue&type=script&lang=ts"
export * from "./ModalComment.vue?vue&type=script&lang=ts"
import style0 from "./ModalComment.vue?vue&type=style&index=0&id=4cecca8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cecca8d",
  null
  
)

export default component.exports